import"./NumberedNavigationItem.css.ts.vanilla.css";var l="_1cd5ljj1",t="_1cd5ljj3",e="_1cd5ljj0",j="_1cd5ljj2";export{l as commonStyle,t as currentStyle,e as labelStyle,j as notCurrentStyle};
